import React from 'react'

type Props = {
  setClickToPlay:any;
}

const PlayOverlay = ({setClickToPlay}: Props) => {

return (
      <div className="h-screen w-screen flex flex-col justify-center items-center fixed left-0 top-0 bottom-0 right-0 z-40 inset-0">
        <div className={`flex flex-col bg-green-50 opacity-[70%] absolute w-full h-full left-0 top-0 bottom-0 right-0`}></div>
       <div className={`relative flex flex-col justify-center items-center z-100 cursor-pointer`} onClick={()=> {setClickToPlay(false); }}>
        <div className={`bg-green-300 absolute rounded-full flex flex-col justify-center items-center p-4 cursor-pointer`}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#339f46" className="w-16 h-16">
              <path fillRule="evenodd" d="M4.5 5.653c0-1.426 1.529-2.33 2.779-1.643l11.54 6.348c1.295.712 1.295 2.573 0 3.285L7.28 19.991c-1.25.687-2.779-.217-2.779-1.643V5.653z" clipRule="evenodd" />
            </svg>
          </div>
       </div>
      </div>
  )
}

export default PlayOverlay